import { useParams, Link } from 'react-router-dom';
import { useState } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ProductPage() {
  const { id } = useParams();
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);

  // Mock product data
  const product = {
    id: id || '1',
    name: 'Histoire de Noël Personnalisée',
    category: 'Livre Numérique',
    price: '29.90',
    rating: 4.9,
    reviews: 247,
    description: 'Offrez à votre enfant une aventure magique où il devient le héros d\'une histoire de Noël inoubliable. Chaque page est personnalisée avec son nom, son apparence et ses préférences pour créer un souvenir unique qui durera toute une vie.',
    images: [
      'https://public.readdy.ai/ai/img_res/e2830d1dc4d0bb857eef18dd3d3dfc71.jpg',
      'https://readdy.ai/api/search-image?query=An%20open%20storybook%20page%20showing%20a%20child%20character%20riding%20in%20Santa%20sleigh%20with%20reindeer%20flying%20over%20snowy%20rooftops%2C%20Pixar%20Disney%20style%2C%20magical%20night%20sky%2C%20stars%20and%20moon%2C%20simple%20background&width=600&height=800&seq=prod1img2&orientation=portrait',
      'https://readdy.ai/api/search-image?query=A%20storybook%20page%20with%20a%20child%20character%20decorating%20a%20Christmas%20tree%20with%20elves%20in%20a%20cozy%20workshop%2C%20Pixar%20Disney%20style%2C%20warm%20colors%2C%20festive%20atmosphere%2C%20simple%20background&width=600&height=800&seq=prod1img3&orientation=portrait',
      'https://readdy.ai/api/search-image?query=A%20storybook%20page%20showing%20a%20child%20character%20opening%20presents%20on%20Christmas%20morning%20with%20family%2C%20Pixar%20Disney%20style%2C%20joyful%20scene%2C%20warm%20lighting%2C%20simple%20background&width=600&height=800&seq=prod1img4&orientation=portrait',
    ],
    features: [
      'Histoire personnalisée de 20 pages',
      'Nom de l\'enfant intégré dans l\'histoire',
      'Personnage créé selon l\'apparence de votre enfant',
      'Format PDF haute résolution',
      'Parfait pour l\'impression',
      'Livraison en moins de 24h',
    ],
    customization: [
      'Nom et âge de l\'enfant',
      'Couleur des cheveux et des yeux',
      'Couleur de peau',
      'Thème préféré (aventure, magie, animaux...)',
      'Message personnalisé',
    ],
    formats: ['PDF haute résolution', 'JPG pour partage', 'Format A4 pour impression'],
  };

  const relatedProducts = [
    {
      id: 2,
      name: 'Aventure dans l\'Espace',
      price: '29.90',
      image: 'https://readdy.ai/api/search-image?query=A%20space%20adventure%20storybook%20showing%20a%20child%20astronaut%20exploring%20colorful%20planets%20with%20friendly%20aliens%2C%20stars%20and%20rockets%2C%20Pixar%20Disney%20style%2C%20vibrant%20cosmic%20colors%2C%20simple%20background&width=400&height=500&seq=related1&orientation=portrait',
    },
    {
      id: 3,
      name: 'Royaume des Princesses',
      price: '29.90',
      image: 'https://readdy.ai/api/search-image?query=A%20princess%20kingdom%20storybook%20with%20a%20child%20character%20in%20a%20magical%20castle%20with%20unicorns%20and%20fairies%2C%20pastel%20colors%2C%20sparkles%2C%20Pixar%20Disney%20style%2C%20simple%20background&width=400&height=500&seq=related2&orientation=portrait',
    },
    {
      id: 4,
      name: 'Portrait Famille Animé',
      price: '39.90',
      image: 'https://readdy.ai/api/search-image?query=An%20animated%20family%20portrait%20in%20Pixar%20Disney%20style%20showing%20happy%20parents%20with%20children%2C%20colorful%20outfits%2C%20warm%20expressions%2C%20simple%20pastel%20background%2C%20professional%203D%20rendering&width=400&height=500&seq=related3&orientation=portrait',
    },
    {
      id: 5,
      name: 'Personnage Enfant 3D',
      price: '34.90',
      image: 'https://readdy.ai/api/search-image?query=A%20cute%203D%20animated%20child%20character%20in%20Pixar%20Disney%20style%20with%20big%20expressive%20eyes%2C%20playful%20pose%2C%20colorful%20clothing%2C%20simple%20gradient%20background%2C%20professional%20quality&width=400&height=500&seq=related4&orientation=portrait',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-6">
          {/* Breadcrumb */}
          <nav className="mb-8">
            <ol className="flex items-center gap-2 font-quicksand text-sm text-gray-500">
              <li>
                <Link to="/" className="hover:text-primary-blue transition-colors cursor-pointer">
                  Accueil
                </Link>
              </li>
              <li>
                <i className="ri-arrow-right-s-line"></i>
              </li>
              <li>
                <Link to="/creations" className="hover:text-primary-blue transition-colors cursor-pointer">
                  Créations
                </Link>
              </li>
              <li>
                <i className="ri-arrow-right-s-line"></i>
              </li>
              <li className="text-gray-900">{product.name}</li>
            </ol>
          </nav>

          {/* Product Section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-24">
            {/* Left - Images */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              {/* Main Image */}
              <div className="mb-6 rounded-4xl overflow-hidden shadow-soft-lg">
                <div className="w-full h-[600px]">
                  <img
                    src={product.images[selectedImage]}
                    alt={product.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute top-4 left-4 px-4 py-2 bg-gradient-to-r from-primary-yellow to-orange-500 text-white font-quicksand font-bold rounded-full shadow-colored-yellow">
                  Bestseller
                </div>
              </div>

              {/* Thumbnail Gallery */}
              <div className="grid grid-cols-4 gap-4">
                {product.images.map((image, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedImage(index)}
                    className={`rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 ${
                      selectedImage === index
                        ? 'ring-4 ring-primary-blue shadow-colored-blue'
                        : 'opacity-60 hover:opacity-100'
                    }`}
                  >
                    <div className="w-full h-24">
                      <img
                        src={image}
                        alt={`${product.name} ${index + 1}`}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </button>
                ))}
              </div>
            </motion.div>

            {/* Right - Product Info */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              {/* Category */}
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-bookmark-line text-primary-blue"></i>
                <span className="font-quicksand text-gray-600">{product.category}</span>
              </div>

              {/* Title */}
              <h1 className="text-4xl font-fredoka font-bold text-gray-900 mb-4">
                {product.name}
              </h1>

              {/* Rating */}
              <div className="flex items-center gap-4 mb-6">
                <div className="flex items-center gap-1">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={`${
                        i < Math.floor(product.rating)
                          ? 'ri-star-fill text-primary-yellow'
                          : 'ri-star-line text-gray-300'
                      }`}
                    ></i>
                  ))}
                </div>
                <span className="font-quicksand text-gray-600">
                  {product.rating} ({product.reviews} avis)
                </span>
              </div>

              {/* Price */}
              <div className="mb-8">
                <div className="text-sm font-quicksand text-gray-500 mb-2">À partir de</div>
                <div className="text-5xl font-fredoka font-bold text-gray-900">
                  {product.price}€
                </div>
              </div>

              {/* Description */}
              <p className="font-quicksand text-gray-700 leading-relaxed mb-8">
                {product.description}
              </p>

              {/* Quantity Selector */}
              <div className="mb-8">
                <label className="block font-quicksand font-semibold text-gray-700 mb-3">
                  Quantité
                </label>
                <div className="flex items-center gap-4">
                  <button
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    className="w-12 h-12 flex items-center justify-center bg-gray-100 rounded-full hover:bg-gray-200 transition-colors cursor-pointer"
                  >
                    <i className="ri-subtract-line text-xl"></i>
                  </button>
                  <span className="text-2xl font-fredoka font-bold text-gray-900 w-12 text-center">
                    {quantity}
                  </span>
                  <button
                    onClick={() => setQuantity(quantity + 1)}
                    className="w-12 h-12 flex items-center justify-center bg-gray-100 rounded-full hover:bg-gray-200 transition-colors cursor-pointer"
                  >
                    <i className="ri-add-line text-xl"></i>
                  </button>
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="space-y-4 mb-8">
                <button className="w-full px-8 py-4 bg-gray-900 text-white font-quicksand font-bold rounded-full hover:shadow-soft-lg transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2">
                  <i className="ri-sparkling-fill"></i>
                  <span>Personnaliser maintenant</span>
                </button>
                <button className="w-full px-8 py-4 bg-white border-2 border-gray-900 text-gray-900 font-quicksand font-bold rounded-full hover:bg-gray-50 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2">
                  <i className="ri-shopping-cart-line"></i>
                  <span>Ajouter au panier</span>
                </button>
              </div>

              {/* Trust Badges */}
              <div className="grid grid-cols-3 gap-4 p-6 bg-neutral-lighter rounded-3xl">
                <div className="text-center">
                  <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center bg-primary-mint/20 rounded-full">
                    <i className="ri-time-line text-primary-mint"></i>
                  </div>
                  <p className="font-quicksand text-xs text-gray-700">Livraison 24h</p>
                </div>
                <div className="text-center">
                  <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center bg-primary-blue/20 rounded-full">
                    <i className="ri-refresh-line text-primary-blue"></i>
                  </div>
                  <p className="font-quicksand text-xs text-gray-700">Modifications gratuites</p>
                </div>
                <div className="text-center">
                  <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center bg-primary-yellow/20 rounded-full">
                    <i className="ri-shield-check-line text-primary-yellow"></i>
                  </div>
                  <p className="font-quicksand text-xs text-gray-700">Garantie satisfait</p>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Tabs Section */}
          <div className="mb-24">
            <div className="border-b border-gray-200 mb-8">
              <div className="flex gap-8">
                <button className="pb-4 font-quicksand font-bold text-gray-900 border-b-2 border-gray-900 cursor-pointer">
                  Détails
                </button>
                <button className="pb-4 font-quicksand font-semibold text-gray-500 hover:text-gray-900 transition-colors cursor-pointer">
                  Personnalisation
                </button>
                <button className="pb-4 font-quicksand font-semibold text-gray-500 hover:text-gray-900 transition-colors cursor-pointer">
                  Formats
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              <div>
                <h3 className="text-2xl font-fredoka font-bold text-gray-900 mb-6">
                  Ce qui est inclus
                </h3>
                <ul className="space-y-4">
                  {product.features.map((feature, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-primary-mint/20 rounded-full mt-0.5">
                        <i className="ri-check-line text-primary-mint text-sm"></i>
                      </div>
                      <span className="font-quicksand text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h3 className="text-2xl font-fredoka font-bold text-gray-900 mb-6">
                  Options de personnalisation
                </h3>
                <ul className="space-y-4">
                  {product.customization.map((option, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-primary-blue/20 rounded-full mt-0.5">
                        <i className="ri-edit-line text-primary-blue text-sm"></i>
                      </div>
                      <span className="font-quicksand text-gray-700">{option}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Related Products */}
          <div>
            <div className="flex items-center justify-between mb-8">
              <h2 className="text-3xl font-fredoka font-bold text-gray-900">
                Produits Similaires
              </h2>
              <Link
                to="/creations"
                className="hidden md:inline-flex items-center gap-2 px-6 py-3 border-2 border-gray-900 text-gray-900 font-quicksand font-semibold rounded-full hover:bg-gray-900 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <span>Voir tout</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {relatedProducts.map((relatedProduct, index) => (
                <motion.div
                  key={relatedProduct.id}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <Link
                    to={`/produit/${relatedProduct.id}`}
                    className="group block bg-white rounded-3xl overflow-hidden shadow-soft hover:shadow-soft-lg transition-all duration-300 cursor-pointer"
                  >
                    <div className="relative w-full h-64 overflow-hidden">
                      <img
                        src={relatedProduct.image}
                        alt={relatedProduct.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-6">
                      <h3 className="text-lg font-fredoka font-bold text-gray-900 mb-3 line-clamp-2">
                        {relatedProduct.name}
                      </h3>
                      <div className="text-2xl font-fredoka font-bold text-gray-900 mb-4">
                        {relatedProduct.price}€
                      </div>
                      <button className="w-full px-6 py-3 bg-gray-900 text-white font-quicksand font-semibold rounded-full group-hover:bg-primary-blue transition-all duration-300 whitespace-nowrap">
                        Voir le produit
                      </button>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}